import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface HeaderActionsPortalProps {
  children: ReactNode;
}

/**
 * HeaderActionsPortal renders action buttons into the header actions slot.
 * Use this to display page-specific actions (buttons, dropdowns, etc).
 *
 * Example:
 * <HeaderActionsPortal>
 *   <DownloadDropdown onDownload={handleDownload} />
 *   <Button onClick={handleCreate}>Create Case</Button>
 * </HeaderActionsPortal>
 */
export function HeaderActionsPortal({ children }: HeaderActionsPortalProps) {
  const portalRoot =
    typeof document !== 'undefined' ? document.getElementById('header-actions-portal-root') : null;

  if (!portalRoot) {
    return null;
  }

  return createPortal(children, portalRoot);
}
